import Input from "../../ui/common/Input";
import React from "react";

type StatisticsSettingsProps = {
  showStatisticsSettings: boolean;
  handleToggleStatistics: Function;
  onInputChange: Function;
  data: any;
};

const StatisticsSettings = ({
  showStatisticsSettings,
  handleToggleStatistics,
  onInputChange,
  data,
}: StatisticsSettingsProps) => {
  const domainValue = data.domain?.value || data.domain?.default || [];
  const domainString = Array.isArray(domainValue) ? domainValue.join(",") : String(domainValue);

  return (
    <div>
      <div
        className="brand-settings-title first"
        onClick={() => {
          handleToggleStatistics();
        }}
      >
        Statistics
      </div>

      <div className={["brand-settings-container", "statistics", showStatisticsSettings && "active"].join(" ")}>
        <div className="statistics-wrapper">
          <div>
            <h4>Domain</h4>
            <textarea
              value={domainString}
              onChange={(e) => onInputChange(e.target.value, "domain", "value")}
            />
          </div>
          <div>
            <h4>AT Internet Auth (Piano)</h4>
            <Input
              label="Client Email"
              separateLines
              value={data.atInternetAuth.clientEmail.value || data.atInternetAuth.clientEmail.default}
              onChange={(e) => onInputChange(e.target.value, "atInternetAuth", "clientEmail")}
            />
            <Input
              label="Private Key"
              separateLines
              value={data.atInternetAuth.privateKey.value || data.atInternetAuth.privateKey.default}
              onChange={(e) => onInputChange(e.target.value, "atInternetAuth", "privateKey")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsSettings;
